//# sourceMappingURL=my-marked-date.interface.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/EZepeda/Desktop/Explora/adminexplora/~/mydatepicker/dist/interfaces/my-marked-date.interface.js
// module id = ../../../../mydatepicker/dist/interfaces/my-marked-date.interface.js
// module chunks = 4